import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_staff/ids/group-id/$id/_$id/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/ids/group-id/$id/members",
      params: { id: params.id },
    });
  },
});
